import React from 'react';
import { connect } from 'react-redux';
import { LoadingIndicator } from 'ui-components/components/loading-indicator';

import Global from '../store/global-selectors';
import { ShipstationConnectReader } from '../store/shipstation-connect/shipstation-connect-reader';
import { ScanToPrintReader } from '../store/scan-to-print/scan-to-print-reader';
import ErrorBoundary from '../components/error-boundary';
import { Cover } from './body-cover';
import MissingConnect from '../components/shipstation-connect/missing/translated';
import { MissingPrinter } from './missing-printer';
import { ReadyToScan } from './ready-to-scan';
import { Scan } from './index';
import { OrderSearchResultModal } from './order-search-result/modal';
import { ScanToVerifyBodyWrapped } from './verify/scan-to-verify-body/context-wrapped';
import { ScanToPrintBody } from './print';
import { availableModes } from './constants';

const isLoading = (state, fulfillmentPlanId) => {
  const entity = Global.selectEntitiesFulfillmentPlanById(state, {
    fulfillmentPlanId,
  });
  return !entity;
};

const determineBody = (mode, shipmentNumber, setScanHeaderFocus, inVerifyOnlyMode) => {
  const isVerifyAndPrint = mode === availableModes.verifyAndPrint;
  if (isVerifyAndPrint || inVerifyOnlyMode) {
    return (
      <ErrorBoundary errorMessageId='scanTo'>
        <ScanToVerifyBodyWrapped
          fulfillmentPlanId={shipmentNumber}
          isVerifyOnly={inVerifyOnlyMode}
          setScanHeaderFocus={setScanHeaderFocus}
        />
      </ErrorBoundary>
    );
  }
  return (
    <ErrorBoundary errorMessageId='scanTo'>
      <ScanToPrintBody fulfillmentPlanId={shipmentNumber} />
    </ErrorBoundary>
  );
};

const getBody = (state, shipmentNumber, isHeaderFocused, setScanHeaderFocus) => {
  const shipstationConnectReader = new ShipstationConnectReader({ state });
  const scanToPrintReader = new ScanToPrintReader({ state });
  const { mode, inVerifyOnlyMode } = scanToPrintReader;

  if (!shipstationConnectReader.hasConnect && !inVerifyOnlyMode) {
    return <MissingConnect />;
  }

  if (scanToPrintReader.inPrintMode && !scanToPrintReader.hasPrinter) {
    return <MissingPrinter />;
  }

  if (scanToPrintReader.isOrderSearch) {
    const { searchValue } = scanToPrintReader.orderSearch;
    return (
      <React.Fragment>
        <ReadyToScan />
        <OrderSearchResultModal searchValue={searchValue} />
      </React.Fragment>
    );
  }

  if (scanToPrintReader.hasError || !shipmentNumber) {
    return <ReadyToScan />;
  }

  if (isLoading(state, shipmentNumber)) {
    return <LoadingIndicator />;
  }

  const body = determineBody(mode, shipmentNumber, setScanHeaderFocus, inVerifyOnlyMode);
  if (isHeaderFocused) {
    return (
      <>
        {body}
        <Cover allowClickEvents onClick={() => setScanHeaderFocus(true)} />
      </>
    );
  }
  return body;
};

const mapStateToProps = (state) => {
  const shipmentNumber = Global.selectScanToPrintFulfillmentPlanId(state);

  return {
    renderBody: (isHeaderFocused, setScanHeaderFocus) => getBody(state, shipmentNumber, isHeaderFocused, setScanHeaderFocus),
    shipmentNumber,
  };
};

export const Connected = connect(mapStateToProps)(Scan);
